import React, { PureComponent } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

// modules
import styles from '../Containers.module.scss';

class About extends PureComponent {
  render() {
    return (
      <Container fluid className={styles.About}>
        <Container>
          <Row>
            <Breadcrumb>
              <LinkContainer exact to="/">
                <BreadcrumbItem>
                  <Link to="/">Home</Link>
                </BreadcrumbItem>
              </LinkContainer>
              <LinkContainer exact to="/about">
                <BreadcrumbItem active>About Nabor</BreadcrumbItem>
              </LinkContainer>
            </Breadcrumb>
          </Row>
        </Container>
        <Container>
          <p>
            About the Naples Area Board of REALTORS<sup>®</sup> and Association of Real
            Estate Professionals (NABOR)
          </p>
          <p>
            The Naples Area Board of REALTORS<sup>®</sup> and Association of Real Estate
            Professionals (NABOR) is a local branch of the Florida Association of REALTORS
            <sup>®</sup> and the National Association of REALTORS<sup>®</sup>. Formed in
            1949, NABOR has served the community for 60 years through its professionalism
            and adherence to a strict code of ethics. With more than 4,000 members, NABOR
            is the largest trade association in the Collier/Lee County Areas.
          </p>
          <p>
            Working for REALTORS<sup>®</sup>, Allied and Affiliate members, NABOR provides
            a facility for education, research and the exchange of information, and
            provides a service to the public and government by fighting for private
            property rights. NABOR offers seminars to its members on all aspects of real
            estate.
          </p>

          <p>
            The term REALTOR<sup>®</sup> is a collective membership mark which identifies
            a real estate professional who is a member of the National Association of
            REALTORS<sup>®</sup>
            and subscribes to and is bound by its code of ethics and professional
            standards.
          </p>

          <p>
            The National Association of REALTORS<sup>®</sup> was formed in 1908 with a
            membership of 120 people. NAR now serves some 850,000 in the real estate
            industry in 50 states, the District of Columbia, Guam, Puerto Rico and the
            Virgin Islands. Through its involvement with international affiliates, NAR is
            truly a part of the global economy.
          </p>

          <p>
            The Florida Association of REALTORS<sup>®</sup> is the largest trade
            association in the state, serving more than 100,000 members. Association
            membership is composed of REALTORS<sup>®</sup>, who are brokers and
            salespeople and affiliate members, who have interests requiring information
            concerning real estate and/or are involved in the real estate profession’s
            allied industries-mortgage brokers, title companies, bankers,
            builder/developers, and real estate attorneys.
          </p>

          <p>
            REALTORS<sup>®</sup> belong to one or more of some 1,500 local associations,
            50 state associations and the National Association of REALTORS<sup>®</sup>.
          </p>

          <p>
            To search the Naples Area Board of REALTORS<sup>®</sup> roster of members and
            service providers, visit the{' '}
            <Link to="/find-naples-agent">NaplesArea.com Member Roster</Link>.
          </p>

          <p>
            To find a home for sale (or other properties for sale in the Naples area),
            visit the{' '}
            <Link to="/find-naples-home">NaplesArea.com property search engine</Link>.
          </p>
        </Container>
      </Container>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/containers/About/About.js